import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BaseComponent } from "src/app/core/abstracts/base.component";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { RouteStateService } from "src/app/core/services/route-state.service";
import { CommonFunctionsService } from "src/app/core/services/common-functions.service";
import { AuthService } from "src/app/core/services/auth.service";
declare var cordova: any;
declare var navigator: any;

@Component({
  selector: "app-breadcrumb",
  template: `
    <div class="location">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumbs mb-1" *ngIf="breadcrumbs.length > 1">
            <div>
              <h1>{{ breadcrumbs[breadcrumbs.length - 1].label }}</h1>
              <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
                <!-- <a  [routerLink]="[breadcrumb.url, breadcrumb.params]" class="location-ders2"> {{ breadcrumb.label }} </a> -->
                <a [routerLink]="[breadcrumb.url]" class="location-ders">
                  {{ breadcrumb.label }}
                </a>
                <a *ngIf="breadcrumbs[i + 1] != null" href="javascript:;" class="location-ders">
                  /
                </a>
              </ng-container>
            </div>
            <a
              [routerLink]="[breadcrumbs[breadcrumbs.length - 2].url]"
              *ngIf="breadcrumbs.length > 1"
              class="btn tablo-new tablo-new-button mt-2  mobile-center"
              style="margin-left: 0px; float: right;height: auto;"
              role="button">
              <i aria-hidden="true" class="uil uil-arrow-left"></i>
              <!-- {{ breadcrumbs[breadcrumbs.length - 2].label }} -->Geri
            </a>
            <a style="display: none !important;" 
                id="goBack" 
                [routerLink]="[breadcrumbs[breadcrumbs.length - 2].url]"
                *ngIf="breadcrumbs.length > 1"></a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [``],
})
export class BreadcrumbComponent implements OnInit {
  /*
https://dev.to/zhiyueyi/create-a-simple-breadcrumb-in-angular-ag5
*/
  breadcrumbs: IBreadCrumb[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeStateService: RouteStateService,
    private commonFunctionsService: CommonFunctionsService,
    private authService: AuthService
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
      });

    //manuel tetiklenirse tekrar breadcrumb oluştur.
    this.routeStateService.breadcrumbService.subscribe(() => {
      this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
    });
  }

  ngAfterViewInit(): void {
    
    if(typeof(cordova) != "undefined"){
      
      if (cordova.platformId === "android"){

        let onBackPress = () => {
          if(this.breadcrumbs.length > 1){
            document.getElementById("goBack").click();
          }
          else{
            if(this.authService.loggedIn()){
              this.commonFunctionsService.showConfirmation('warning', 'Çıkış Yap', 'Çıkış yapmak istiyor musunuz?', () => {
                document.getElementById("logout").click();
              })
            }
            else{
              navigator.app.exitApp();
            }
            
          }
        };
      
        document.addEventListener('backbutton', onBackPress, false);
      }
      else if(cordova.platformId === "ios"){

      }
    }
    
  }

  buildBreadCrumb(
    route: ActivatedRoute,
    url: string = "",
    breadcrumbs: IBreadCrumb[] = []
  ): IBreadCrumb[] {
    //If no routeConfig is avalailable we are on the root path
    let label =
      route.routeConfig && route.routeConfig.data
        ? route.routeConfig.data.breadcrumb
        : "";
    let path =
      route.routeConfig && route.routeConfig.data ? route.routeConfig.path : "";
    //console.log('path1: ' + path);;
    // if(label.length > 20){
    //   label = label.substring(0,20) + "...";
    // } 
    // If the route is dynamic route such as ':id', remove it

    const isDynamicRoute = path.includes(":");
    if (isDynamicRoute && !!route.snapshot) {
      path.split("/").forEach((element, index) => {
        const paramName = element.split(":")[1];
        path = path.replace(element, route.snapshot.params[paramName]);
        if (label) {
        } else {
          label = route.snapshot.params[paramName];
        }
      });
    }

    //console.log('path2: ' + path);
    //In the routeConfig the complete path is not available,
    //so we rebuild it each time
    const nextUrl = path ? `${url}/${path}` : url;

    // console.log('url: ' + url);

    // console.log('nextUrl: ' + nextUrl);
    // console.log('----------: ');

    const breadcrumb: IBreadCrumb = {
      label: label,
      url: nextUrl,
    };
    // Only adding route with non-empty label
    const newBreadcrumbs = breadcrumb.label
      ? [...breadcrumbs, breadcrumb]
      : [...breadcrumbs];
    if (route.firstChild) {
      //If we are not on our current path yet,
      //there will be more children to look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
}
interface IBreadCrumb {
  label: string;
  url: string;
}
